import { useState, useEffect } from 'react';
import Skeleton from '@carvana/ds-skeleton';
import { getUserState } from '@carvana/core-auth';

import styles from '../HeroLoadingFallback.module.css';
import VehicleEntry from '../VehicleEntry';
import { StyledCard } from '../VehicleEntry/Entry.styles';
import SummaryTiles from './SummaryTiles';
import {
  Background,
  Heading,
  HeadingWrapper,
  HeroContainer,
  HeroFoldContainer,
  SubTitle
} from './Hero.styles';
import { headerCopy, subHeaderCopy } from './Hero.content';
import { getHeroHeading } from './getHeroHeading';
import * as vehicleOwnershipSignalsExperiment from 'experiments/car-stc-vehicle-ownership-signals';
import WithExperiment from 'components/WithExperiment';
import useGetSummaries from 'shared/hooks/useGetSummaries';
import { LifecycleState } from 'api/GraphQL/queries/getVehicleSummaries';

const Hero = () => {
  const [hasMounted, setHasMounted] = useState(false);

  const {
    user: { given_name: givenName }
  } = getUserState();

  const { data } = useGetSummaries();
  const summaries = data?.vehicleSummaries;
  const showEntryWidget = !summaries || summaries.length === 0;
  const heading = showEntryWidget
    ? headerCopy
    : getHeroHeading(givenName, summaries?.[0]?.lifecycleState);

  const shouldBucket = summaries?.some(s => s.lifecycleState === LifecycleState.Expired) ?? false;

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const renderRightColumn = () => {
    if (showEntryWidget)
      return (
        <StyledCard>
          <VehicleEntry />
        </StyledCard>
      );
    const tiles = shouldBucket ? (
      <WithExperiment {...vehicleOwnershipSignalsExperiment}>
        <SummaryTiles summaries={summaries!} />
      </WithExperiment>
    ) : (
      <SummaryTiles summaries={summaries!} />
    );
    return tiles;
  };

  return (
    <Background>
      <HeroContainer>
        <HeroFoldContainer>
          <HeadingWrapper>
            {hasMounted ? (
              <>
                <Heading>{heading}</Heading>
                <SubTitle style={{ whiteSpace: 'pre-wrap' }}>{subHeaderCopy}</SubTitle>
              </>
            ) : (
              <>
                <Heading as="div" className={styles.relative}>
                  <span className={styles.hidden} aria-hidden="true">
                    {heading}
                  </span>
                  <div className={styles.absoluteOverlay}>
                    <Skeleton width="100%" height="100%" />
                  </div>
                </Heading>
                <SubTitle className={styles.relative}>
                  <span className={styles.hiddenPreWrap} aria-hidden="true">
                    {subHeaderCopy}
                  </span>
                  <div className={`${styles.absoluteOverlay} ${styles.flexColumn}`}>
                    <Skeleton width="100%" height="24px" />
                    <Skeleton width="65%" height="24px" />
                  </div>
                </SubTitle>
              </>
            )}
          </HeadingWrapper>
          {renderRightColumn()}
        </HeroFoldContainer>
      </HeroContainer>
    </Background>
  );
};

export default Hero;
